/* eslint-disable */
import * as React from "react";
import { CalendarBASFPropsType } from "../types";
import { CalendarMultipleValueType, CalendarValueType } from "../../../shared";

type InputPropsType = {
  setRef: (elem: HTMLInputElement) => void,
  label?: string,
  disabled?: boolean,
  onChange: (value: CalendarMultipleValueType | CalendarValueType) => void,
};

type UseInputPropsResult = [InputPropsType, HTMLInputElement | undefined];

export function useInputProps(props: CalendarBASFPropsType, setCalendarValue: (value: CalendarMultipleValueType | CalendarValueType) => void): UseInputPropsResult {
  const [inputRef, setInputRef] = React.useState<HTMLInputElement>();

  const setRef = React.useMemo(() => {
    const initInputRef = (elem: HTMLInputElement) => {
      if (elem !== inputRef) {
        setInputRef(elem);
      }
    };
    return initInputRef;
  }, []);

  const inputProps = React.useMemo(() => {
    return {
      setRef,
      disabled: props.disabled,
      label: props.label,
      onChange: setCalendarValue,
    };
  }, [props.label, props.disabled, setCalendarValue]);

  return [inputProps, inputRef];
}
